import './catalogWheelPicker.css';

function thumbnail(item) {
  const frame = document.createElement('div');
  frame.className = 'catalog-wheel-photo';
  const fallback = document.createElement('small');
  fallback.textContent = 'Sin foto';
  frame.append(fallback);
  if (item?.thumbnailUrl) {
    const image = document.createElement('img');
    image.alt = '';
    image.loading = 'lazy';
    image.decoding = 'async';
    image.src = item.thumbnailUrl;
    fallback.hidden = true;
    image.addEventListener('error', () => { image.remove(); fallback.hidden = false; }, { once: true });
    frame.append(image);
  }
  return frame;
}

export class CatalogEquipmentPicker {
  constructor(select, { type = 'wheel', label = 'Ruedas' } = {}) {
    this.type = type;
    this.label = label;
    this.prompt = type === 'wheel' ? 'Elegir rueda publicada' : `Elegir ${label.toLowerCase()}`;
    this.select = select;
    this.items = [];
    this.select.hidden = true;
    const host = select.parentElement;
    host.classList.add('calibrator-wheel-field');
    this.root = document.createElement('details');
    this.root.className = 'catalog-wheel-picker';
    this.root.dataset.equipmentType = type;
    this.root.setAttribute('name', 'calibrator-equipment-picker');
    this.summary = document.createElement('summary');
    this.summary.title = this.prompt;
    this.panel = document.createElement('div');
    this.panel.className = 'catalog-wheel-options';
    this.panel.setAttribute('role', 'group');
    this.panel.setAttribute('aria-label', `${label} · ítems publicados`);
    this.note = document.createElement('p');
    this.note.className = 'catalog-wheel-note';
    this.note.setAttribute('role', 'status');
    this.root.append(this.summary, this.panel);
    host.append(this.root, this.note);
    this.root.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.root.open) {
        event.preventDefault();
        event.stopPropagation();
        this.root.open = false;
        this.summary.focus();
      }
    });
    this.setItems([]);
  }

  setItems(items) {
    this.items = items;
    this.select.replaceChildren(new Option(this.prompt, ''), ...items.map((item) => new Option(item.name || item.id, item.id)));
    this.panel.replaceChildren();
    for (const item of items) {
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.equipmentId = item.id;
      if (this.type === 'wheel') button.dataset.wheelId = item.id;
      button.title = `${item.name || item.id} · ${item.id}`;
      const name = document.createElement('strong');
      name.textContent = item.name || item.id;
      button.append(thumbnail(item), name);
      button.addEventListener('click', () => {
        this.select.value = item.id;
        this.select.dispatchEvent(new Event('change', { bubbles: true }));
        this.root.open = false;
        this.summary.focus();
      });
      this.panel.append(button);
    }
    if (!items.length) {
      const empty = document.createElement('p');
      empty.textContent = this.type === 'wheel' ? 'No hay ruedas publicadas disponibles.' : `No hay ítems publicados de ${this.label.toLowerCase()}.`;
      this.panel.append(empty);
    }
  }

  sync(id) {
    const selected = this.items.find((item) => item.id === id);
    this.select.value = selected?.id || '';
    const name = document.createElement('strong');
    name.textContent = selected?.name || selected?.id || this.prompt;
    this.summary.replaceChildren(thumbnail(selected), name);
    this.panel.querySelectorAll('[data-equipment-id]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.equipmentId === selected?.id));
    });
    this.note.textContent = !this.items.length
      ? `Publicá ${this.label.toLowerCase()} en el catálogo para poder elegir aquí.`
      : selected ? '' : !id ? 'Sin asignar: el juego usará su selección predeterminada hasta que elijas un ítem.'
        : this.type === 'wheel' ? `La rueda actual (${id}) no está publicada. Elegí una rueda de la lista para reemplazarla.`
          : `El ítem actual (${id}) no está publicado. Elegí otro de la lista para reemplazarlo.`;
    this.note.hidden = !this.note.textContent;
  }

  dispose() { this.root.remove(); this.note.remove(); this.select.hidden = false; }
}

export class CatalogWheelPicker extends CatalogEquipmentPicker {}
